import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './i18n';
import { Provider } from 'react-redux';
import { store } from 'store/index';

const container = document.getElementById('root');
const root = createRoot(container);

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  // const { worker } = await import('./mocks/browser');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  // return worker.start();
}

enableMocking().then(() => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  );
});
